import { SPRINT } from '@atlassian/jira-software-filters/src/common/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { FILTERED_CARD_CLEAR } from '../../../actions/card/filtered-cards/index.tsx';
import { FILTERS_SET, SET_ALL_FILTERS, FILTERS_JQL_SET } from '../../../actions/filter/index.tsx';
import { SELECT_SPRINTS, CLEAR_SELECTED_SPRINTS } from '../../../actions/sprints/select/index.tsx';
import type { Action } from '../../../types.tsx';
import { type SprintsState, initialSprintsState } from './types.tsx';

export const sprintsReducer = (
	state: SprintsState = initialSprintsState,
	action: Action,
): SprintsState => {
	if (action.type === SELECT_SPRINTS) {
		const { sprintFilterIds } = action.payload;
		return { selected: sprintFilterIds };
	}

	if (action.type === CLEAR_SELECTED_SPRINTS || action.type === FILTERED_CARD_CLEAR) {
		return { selected: [] };
	}

	if (action.type === FILTERS_SET && action.payload.filterType === 'SPRINT') {
		const { values } = action.payload;
		return { selected: Array.isArray(values) ? values : [values] };
	}

	if (
		action.type === SET_ALL_FILTERS ||
		(action.type === FILTERS_JQL_SET && fg('tmp_filter_refinement_sprint_goals'))
	) {
		return {
			selected: action.payload.filters[SPRINT] || [],
		};
	}

	return state;
};
